import { render, staticRenderFns } from "./Dependent.vue?vue&type=template&id=11b7ec2a&scoped=true&"
import script from "./Dependent.ts?vue&type=script&lang=ts&"
export * from "./Dependent.ts?vue&type=script&lang=ts&"
import style0 from "./Dependent.vue?vue&type=style&index=0&id=11b7ec2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b7ec2a",
  null
  
)

export default component.exports